import React from "react";

export const RightBlackArrowIcon = () => {
    return (
        <svg width="36" height="40" viewBox="0 0 36 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_179_3780)">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M15.2455 21.5283L15.6633 21.0957H18.078L16.4948 22.7349C16.3311 22.9043 16.1057 23 15.8701 23C15.1037 23 14.7131 22.0795 15.2455 21.5283ZM17.6186 14.4287L16.4948 13.2651C16.3311 13.0957 16.1057 13 15.8701 13C15.1232 13 14.7331 13.8743 15.2067 14.429H15.2074L18.32 17.6516C18.5072 17.8454 18.5072 18.1526 18.32 18.3463L15.6654 21.0947H18.0801L20.7347 18.3463C20.9219 18.1526 20.9219 17.8454 20.7347 17.6516L17.6217 14.4287H17.6186Z"
                      fill="black"/>
            </g>
            <defs>
                <filter id="filter0_d_179_3780" x="-13" y="-10" width="60" height="60" filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                   result="hardAlpha"/>
                    <feOffset dy="2"/>
                    <feGaussianBlur stdDeviation="7.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_179_3780"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_179_3780" result="shape"/>
                </filter>
            </defs>
        </svg>
    );
}